import React from 'react'
import parse from 'html-react-parser'
import Link from '../utils/link'
import { RightArrow } from './icons'

const FullScreenBasicContent = ({title, h1, content, button}) => {

  return (
    <section className={`full-screen-basic${button?.title === '' ? '' : ' full-screen-basic--button'}`}>
      <div className="full-screen-basic__inner">
        {title && h1 && <h1 data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>{parse(title)}</h1>}
        {title && !h1 && <h3 data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>{parse(title)}</h3>}
        { content && <div data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>{parse(content)}</div> }
        { button?.url && button?.title && 
          <Link to={button.url} className='full-screen-basic__button' data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>
            <span>{button.title}</span>
            <RightArrow />
          </Link>
        }
      </div>
    </section>
  )
}

export default FullScreenBasicContent